import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { OFFICES, NAV_LINKS } from "@/lib/data";


export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="text-slate-300 relative overflow-hidden"
      style={{ background: "#24356E" }}
    >
      {/* Decorative grid pattern */}
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />
      <div className="zt-container py-10 md:py-12 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-4">
            <div className="mb-3">
              <img
                src="https://customer-assets-v7afamib.emergentagent.net/job_corp-web-launch/artifacts/g26xltkr_ZTHealth_Logo_Horizontal_no%20tag_White.webp"
                alt="ZT Health"
                data-testid="footer-logo"
                className="h-10 md:h-12 w-auto select-none"
                draggable="false"
              />
            </div>
            <p className="zt-tagline text-xs font-semibold uppercase tracking-[0.2em] mb-4" style={{ color: "#3397AC" }}>
              Better Health. Stronger Communities.
            </p>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
              A diversified healthcare investment platform delivering essential, community-based care across Texas. A portfolio group of{" "}
              <a
                href="https://ztcorporate.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-ztcorp-link"
                className="text-white hover:text-white underline decoration-slate-500 underline-offset-2 hover:decoration-white transition-colors"
              >
                ZT Corporate
              </a>
              .
            </p>
            <div className="mt-5 flex items-center gap-4">
              <Link
                to="/contact"
                data-testid="footer-cta-contact"
                className="inline-flex items-center gap-2 px-5 py-2.5 text-xs font-semibold uppercase tracking-wide text-white border border-slate-600 hover:border-white hover:bg-white/5 transition-all"
              >
                Connect With Our Team →
              </Link>
              <a
                href="https://www.linkedin.com/company/zt-health"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ZT Health on LinkedIn"
                data-testid="footer-linkedin"
                className="w-10 h-10 inline-flex items-center justify-center border border-slate-600 text-slate-300 hover:text-white hover:border-white hover:bg-white/5 transition-all"
              >
                <Linkedin size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-white mb-4">Navigate</p>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-slate-400 hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-6">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-white mb-4">Office Locations</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {OFFICES.map((o) => (
                <div key={o.city} data-testid={`footer-office-${o.city.toLowerCase().replace(/\s+/g, "-")}`}>
                  <p className="text-white font-semibold text-sm mb-1">{o.city}</p>
                  <p className="text-slate-400 text-sm leading-relaxed">
                    {o.address1}<br />
                    {o.address2}
                    {o.phone && (
                      <>
                        <br />
                        P:{" "}
                        <a href={`tel:${o.phone.replace(/[^0-9+]/g, "")}`} className="hover:text-white">
                          {o.phone}
                        </a>
                      </>
                    )}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800 relative">
        <div className="zt-container py-4 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} ZT Health. A portfolio group of ZT Corporate. All rights reserved.</p>
          <p className="zt-tagline tracking-wider uppercase" style={{ color: "#3397AC" }}>Better Health. Stronger Communities.</p>
        </div>
      </div>
    </footer>
  );
}
